

import Vue from 'vue'
import App from './App'
import router from './router'
import '../static/css/common.css'
import store from '../store'
import '../utils/rem'
import axios from 'axios'
import WechatAuth from 'vue-wechat-auth'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import VueCropper from 'vue-cropper'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import AlertPlugin from 'vux/src/plugins/alert/index.js'

import setting from '../server/settings'
import {mapMutations} from 'vuex'
Vue.use(AlertPlugin);
Vue.use(LoadingPlugin)
Vue.use(VueCropper)
Vue.use(Viewer);
Vue.prototype.$http = axios;
import md5 from 'js-md5'; 

Viewer.setDefaults({


toolbar: false,

navbar: false,
});

Vue.prototype.$md5 = md5
Vue.prototype.$msgbox = function(title, msg) {
this.$vux.alert.show({
title: title,
content: msg
});
}

Vue.prototype.$msgbox1 = function(title, msg) {
this.$vux.alert.show({
title: title,
content: msg
});
setTimeout(() => {
this.$vux.alert.hide()
}, 1000)
}
Vue.config.productionTip = false;

Vue.use(WechatAuth , {
router, // 路由实例对象
appid: setting.appid, // 您的微信appid
responseType: 'code',  // 返回类型，请填写code
scope: 'snsapi_userinfo', // 应用授权作用域，snsapi_base （不弹出授权页面，直接跳转，只能获取用户openid），snsapi_userinfo （弹出授权页面，可通过openid拿到昵称、性别、所在地。并且，即使在未关注的情况下，只要用户授权，也能获取其信息）
getCodeCallback (code, next) {
axios.post('http:'+setting.mpmanageback+'/wx/code/getCode', {
code: code,
appid:setting.appid,
state: ''
}).then(response => {
console.log(code);
let data = response.data;
let accessToken = data.accesstoken;
let openId = data.userInfo['openId']
store.commit('changeOpen_id',openId)
store.commit('changeNickname',data.userInfo['nickname'])
store.commit('changeHeadImgUrl',data.userInfo['headImgUrl'])
window.localStorage.setItem('nickname', data.userInfo['nickname'])
window.localStorage.setItem('headImgUrl', data.userInfo['headImgUrl'])
window.localStorage.setItem('accesstoken', accessToken)
window.localStorage.setItem('openId', data.userInfo['openId'])
if (accessToken&&openId) {
next(accessToken) 
} else {
next() 
}
}).catch(() => {
next() 
})
}
})
/* eslint-disable no-new */
new Vue({
el: '#app',
store,
router,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js